import * as d3 from 'd3';
import React, { useEffect, useRef, useState } from 'react';
import * as Newick  from './utils/Newick'
import './GiChart.css';
import { RGBColor } from 'd3';

function GiPhylogram(props:any) {
    const svgRef:any = useRef();
    const newickData    = props.newickData;
    const detailData    = props.detailData;
    const vafData       = props.vafData
    const initData:any  = props.initialization;

    let width:number  = initData.width;
    let height:number = initData.height;
    let legend_field:string = initData.legend_field;
    let callback_after_mouseover_path:Function = initData.callback_after_mouseover_path; 
    let callback_after_click_path:Function = initData.callback_after_click_path;
    let callback_after_click_reck:Function = initData.callback_after_click_reck;


    let vaf_legend:boolean = initData.vaf_legend;
    let vafColorScale:any;
    let plotMargins = {
        top: 30,
        bottom: 20,
        left: 30,
        right: 150,
        vaf_legend_width: 20,
        vaf_legend_height: 200

        };

    let svg:d3.Selection<SVGGElement, any, any, any>;
    let treeGroup:d3.Selection<SVGGElement, any, any, any> ;
    let nodeMap:any = {}
    let xscales:any[] = [];
    let link:any;
    // Leaves whose hover-triggered highlight (on the linked human figure) is
    // currently "on". A leaf's own mouseout removes it here directly; clearHoverOnly
    // is a fallback for cases where that mouseout doesn't reach this specific leaf
    // (e.g. a click's .raise() shifted stacking order right as the pointer moved away).
    let hoveredLeafData:Set<any> = new Set();

    ////// Set up the data
    const [data, nodeCount, colorCategoryValue] = Newick.parse(newickData, detailData, initData.detail_title_field, initData.legend_field);

    let tempHeight:number = (nodeCount * 10);

    if(initData.min_height != null && tempHeight < initData.min_height){
        height = initData.min_height;
    }else if(initData.max_height != null && tempHeight > initData.max_height){
        height = initData.max_height;
    }else{
        height = tempHeight;
    }

    let treeWidth:number  = width - plotMargins.left - plotMargins.right;

    if(vaf_legend){
        treeWidth = treeWidth - plotMargins.vaf_legend_width;
        plotMargins.left = plotMargins.left + plotMargins.vaf_legend_width;
        vafColorScale = d3.scaleSequentialSymlog()
                          .domain([50, 0])
                          .interpolator(d3.interpolateSpectral);
                          
                          
    }

    let treeHeight:number = height - plotMargins.top - plotMargins.bottom;
    let tree = d3.hierarchy(data, d => d.branchset)
                 .sum(d => 1)
                 .sort((a, b) => {
                    
                    let sortValue:number = d3.descending(a.value, b.value)

                    if(sortValue === 0){
                        sortValue = d3.descending(a.data.name, b.data.name)
                    }

                    return sortValue
                 });
                 // .sum(d => d.branchset ? 0 : 1)
                 //.sort((a, b) => d3.ascending(a.data.length, b.data.length));
    // console.log(tree)

    let cluster = d3.cluster()
                 .size([treeHeight, treeWidth])
                 .separation((a: any, b: any) => 1);

    let nodes = cluster(tree);

    // color
    colorCategoryValue.sort();

    let color = d3.scaleOrdinal()
                  .domain(colorCategoryValue)
                  .range(d3.schemeCategory10)
    
    // callback 
    // draw the vaf rect for bulk id
    let highlightBulkG:any;
    let earlyBranchLineageIds:any = {};
    
    initData.onDrawVafRect = function(bulkId: string){
        if(vafData && vafData[bulkId] && vafColorScale){
            let copiedEarlyBranchLineageIds:any =  { ...earlyBranchLineageIds};

            let bulkVafData:any = vafData[bulkId];
            let nodeKeys:string[] = Object.getOwnPropertyNames(bulkVafData);

            if(highlightBulkG === undefined){
                highlightBulkG= treeGroup.append("g");
            }

            highlightBulkG.selectAll("g").remove();
            
            let highlightBulkGroupRectG:any = highlightBulkG.append("g");
            let highlightBulkTextG:any = highlightBulkG.append("g");
            
            
            nodeKeys.forEach((nodeKey: string) => {

                if(nodeMap[nodeKey]){
                    delete copiedEarlyBranchLineageIds[nodeKey];
                    let rankVaf:any =  bulkVafData[nodeKey].rankVaf;
                    let rankKeys:string[] = Object.getOwnPropertyNames(rankVaf);
                    let rankDatas: any[] = [];
                    let xscale:any = xscales[nodeMap[nodeKey].xscale_index]
                    let defaultWidth:number = xscale(1);

                    rankKeys.forEach((rankKey: string) => {
                        rankDatas.push(rankVaf[rankKey]);
                    });

                    rankDatas.sort((a, b)=> a.rank - b.rank)

                    let beforeRectWidth:number = 0;

                    let highlightBulkRectG:any = highlightBulkGroupRectG.append("g");
                    
                    let xData:number = parseFloat(nodeMap[nodeKey].x) 
                    

                    rankDatas.forEach((rankData:any, index:number) => {
                        xData += beforeRectWidth;
                        let currentRectWidth = defaultWidth * rankData.n_vars_same_rank

                        let vafPecentage:number = rankData.vaf*100

                        highlightBulkRectG.append("rect")
                                    .attr("fill", vafColorScale(vafPecentage))
                                    .attr("opacity", "1")
                                    .attr("stroke", "black")
                                    .attr("stroke-width", 0)
                                    .attr("x", xData)
                                    .attr("y", nodeMap[nodeKey].y -4)
                                    .attr("width", currentRectWidth)
                                    .attr("height", 7)
                                    .attr("rank",rankData.rank)
                                    .attr("node-name",nodeKey)
                                    .on("mouseover", mouseoveredOnRect(nodeMap[nodeKey].node, true))
                                    .on("mouseout", mouseoveredOnRect(nodeMap[nodeKey].node,false));

                        highlightBulkTextG.append("svg:text")
                                          .text(vafPecentage.toFixed(1))
                                          .attr("text-anchor", 'end')
                                          .attr('font-size', '9px')
                                          .attr("font-weight", "bold")
                                          .attr('fill', '#000000')
                                          .attr("transform", `translate(${xData  + 9}, ${nodeMap[nodeKey].y + 22})rotate(65)`);

                                          beforeRectWidth = currentRectWidth;
                    });

                    highlightBulkRectG.selectAll("rect")
                                    .style("cursor", "pointer")
                                    .on("click", mouseclickOnRect(bulkId, nodeMap[nodeKey], highlightBulkRectG, highlightBulkG));

                }

                // if(link){
                //     link.on("click", mouseclickOnRect(bulkId, undefined, undefined, highlightBulkG))
                //         .style("cursor", "pointer")
                // }
            })

            let earlyBranchKeys:string[] = Object.getOwnPropertyNames(copiedEarlyBranchLineageIds);
            earlyBranchKeys.forEach((nodeKey: string) => {
                let xscale:any = xscales[nodeMap[nodeKey].xscale_index];
                let xData:number = parseFloat(nodeMap[nodeKey].x) 
                let highlightBulkRectG:any = highlightBulkG.append("g");

                highlightBulkRectG.append("svg:text")
                .text("N/A")
                .attr("text-anchor", 'end')
                .attr('font-size', '8px')
                .attr("font-weight", "bold")
                .attr('fill', '#000000')
                .attr("transform", `translate(${xData  + 8}, ${nodeMap[nodeKey].y + 18})rotate(65)`);

            });
            
        }

    }

    // Draw path
    function rightAngleDiagonal() {
        let projection = function projection(d: any) { return [d.y, d.x]; }
        
        let path = function path(pathData: any) {
            return "M" + pathData[0] + ' ' + pathData[1] + " " + pathData[2];
        }
        
        function diagonal(diagonalPath: any, i: number) {
            let source = diagonalPath.source,
                target = diagonalPath.target,
                pathData = [source, {x: target.x, y: source.y}, target];
            pathData = pathData.map(projection);
            return path(pathData)
        }
        
        diagonal.projection = function(x: any) {
            if (!arguments.length) return projection;
            projection = x;
            return diagonal;
        };
        
        diagonal.path = function(x: any) {
            if (!arguments.length) return path;
            path = x;
            return diagonal;
        };
        
        return diagonal;
    }

    function scaleBranchLengths(rootNode: any, width: number) {
        // Visit all nodes and adjust y pos width distance metric
        let rootDists: number[] = [];
        let xscalesDists: number[] = [];

        let visitPreOrder = function(root: any, callback: any) {
            callback(root)
            if (root.children) {
                for (var i = root.children.length - 1; i >= 0; i--){
                    visitPreOrder(root.children[i], callback)
                };
            }
        }
        visitPreOrder(rootNode, function(node: any) {
            node.rootDist = (node.parent ? node.parent.rootDist : 0) + (node.data.length || 0)
            rootDists.push(node.rootDist);
        })
    
        rootDists.sort(d3.ascending);

        //const maxRootDists:any = d3.max(rootDists);

        const standardWidth:number = width / rootDists.length;

        for(let i=0; i < rootDists.length; i++){

            if(i === 0 || i === (rootDists.length - 1)){
                xscalesDists.push(rootDists[i]);
                xscalesDists.push(i);

            }else{
                let diffDist:number = rootDists[i+1] - rootDists[i];
                
                if( diffDist >  (rootDists[i]*2)) {
                    xscalesDists.push(rootDists[i]);
                    xscalesDists.push(i); 

                    if( i !== (rootDists.length - 2)){
                        xscalesDists.push(rootDists[i+1]);
                        xscalesDists.push(i+1); 
                    }
                }
            }
        };

        for(let i=0; i < xscalesDists.length; i+=4){
            if( i === 0){
                xscales.push(d3.scaleLinear()
                               .domain([xscalesDists[i], xscalesDists[i+2]])
                               .range([0, xscalesDists.length === 4 ? width : standardWidth * (xscalesDists[i+3]-1)]));
                
            }else{
                let rangeWidth = standardWidth * (xscalesDists[i+3]-1)

                if(i ===(xscalesDists.length - 4)){
                    rangeWidth = width;
                }

                if((xscalesDists[i+2] - xscalesDists[i]) >= 1000){
                    xscales.push(d3.scaleLog()
                                .domain([xscalesDists[i], xscalesDists[i+2]])    
                                .range([standardWidth * xscalesDists[i+1], rangeWidth ]));
                }else{
                    xscales.push(d3.scaleLinear()
                                .domain([xscalesDists[i], xscalesDists[i+2]])    
                                .range([standardWidth * xscalesDists[i+1], rangeWidth ]));
                }
            }
        }

        visitPreOrder(rootNode, function(node: any) {

            xscales.forEach((xscale:any, index:number) => {
                if(xscale.domain()[0] <= node.rootDist && node.rootDist <= xscale.domain()[1]) {
                    node.y = xscale(node.rootDist);
                    node.xscale_index = index;

                    if(index === 0 && node.parent ){
                        earlyBranchLineageIds[node.data.name] = node;
                    }

                    return false;
                }
            });
        })
        return xscales
    }

    // d3's .raise() (still used for the single directly-hovered/clicked element)
    // can shift stacking order right as the pointer moves away, which can make the
    // browser dispatch mouseout to a different node than the one that received
    // mouseover - leaving part of the hover cascade, and the linked human figure
    // highlight it drove, stuck active. hoveredLeafData is the source of truth for
    // which leaves still owe a "hover off" notification; sweeping it here (using
    // that bookkeeping rather than inspecting visual classes, which a click can
    // have already changed for its own reasons) is what actually stays correct.
    function clearHoverOnly(){
        if(!treeGroup){
            return;
        }

        hoveredLeafData.forEach(function(leafData:any){
            if(callback_after_mouseover_path){
                callback_after_mouseover_path(leafData, false, false);
            }
        });
        hoveredLeafData.clear();

        treeGroup.selectAll("path.link").each(function(this: any){
            if(!d3.select(this).classed("selected")){
                d3.select(this).classed("link--active", false);
            }
        });

        treeGroup.selectAll("path.link-extension--active")
                 .classed("link-extension--active", false);

        treeGroup.selectAll("text").each(function(this: any){
            const textNode = d3.select(this);
            if(textNode.classed("label--active") && !textNode.classed("selected")){
                textNode.classed("label--active", false).attr("fill", "black");
            }
        });

        treeGroup.selectAll(".rect--active2")
                 .classed("rect--active2", false)
                 .attr("transform", `translate( -100 , -100 )`);

        treeGroup.selectAll("text.label--active2").each(function(this: any){
            const textNode = d3.select(this);
            if(!textNode.classed("selected")){
                textNode.classed("label--active2", false)
                        .attr("transform", `translate( -100 , -100 )`);
            }
        });
    }

    function mouseoveredOnLabel(active:boolean ){
        return function(this: any, event: any, d: any) {

            if(d3.select(this).classed("selected") === undefined){
                d3.select(this).classed("selected", false).raise();
            }

            // Notify regardless of the "selected" guard below: hover and click are
            // tracked as independent signals downstream (see GiHuman's
            // change_on_human), so hover's own on/off must stay balanced even for a
            // label that's also click-selected.
            //
            // Order matters here: on mouseout, remove/notify for this leaf *before*
            // sweeping stale state (clearHoverOnly), otherwise the sweep would find
            // it still in hoveredLeafData and fire a second, duplicate "off" for it.
            // On mouseover, sweep first so a real stale entry doesn't get added back
            // by this same call.
            if(!active){
                if(callback_after_mouseover_path){
                    callback_after_mouseover_path(d.data, false, false);
                }
                hoveredLeafData.delete(d.data);
                clearHoverOnly();
            }else{
                clearHoverOnly();
                if(callback_after_mouseover_path){
                    callback_after_mouseover_path(d.data, true, false);
                }
                hoveredLeafData.add(d.data);
            }

            if(d3.select(this).classed("selected") === false) {
                if(active){
                    d3.select(this).attr("fill", d3.select(this).attr("fill2"));
                }else{
                    d3.select(this).attr("fill", "black");
                }

                d3.select(this).classed("label--active", active);

                d3.select(d.linkExtensionNode).classed("link-extension--active", active).raise();

                do{
                    let parentSelected = active;

                    // if(d.children !== undefined){
                    //     for(let i=0; i<d.children.length; i++){
                    //         if(d3.select(d.children[i].linkNode).classed("selected")){
                    //             parentSelected = true;
                    //             break;
                    //         }
                    //     }
                    // }
    
                    //d3.select(d.linkNode).classed("selected", parentSelected).classed("link--active", parentSelected).raise();
                    if(d.linkNode !== undefined && !d3.select(d.linkNode).classed("selected")){
                        // No .raise() here: this walks every ancestor on each hover, and
                        // reordering that many siblings under the cursor is what made
                        // the browser lose track of which element a click should land on.
                        d3.select(d.linkNode).classed("link--active", parentSelected);
                    }
                }
                while (d = d.parent);
            }
        };
    }

    let clickPathDatas:any = {};

    // Applies (or clears) the click-selected bold state for one clicked branch:
    // the branch's own path, its ancestor chain, and its descendant labels/paths.
    // Shared by mouseClickOnPath both for the branch being clicked and for
    // clearing whichever branch was previously selected (single-select).
    function applyPathSelection(pathD:any, pathNode:any, selected:boolean){

        d3.select(pathNode).classed("selected", selected).classed("link--active2", selected).raise();

        // childen
        function childPathActive(children:any[]){
            children.forEach(child => {
                childActive(child);
            })
        }

        /// parents
        let source = pathD.source;
        let isSelectedParent = false;

        do {
            if(source.linkNode !== undefined && d3.select(source.linkNode).classed("selected")){
                isSelectedParent = true;
                break;
            }
        }
        while (source = source.parent);


        // TextNode

        function childActive(child:any){
            if(child.children){
                childPathActive(child.children);
            }else{

                if(selected){
                    d3.select(child.textNode).attr("fill", d3.select(child.textNode).attr("fill2"));
                }else{
                    d3.select(child.textNode).attr("fill", "black");
                }
                d3.select(child.textNode).classed("selected", selected).classed("label--active", selected);

                // Clicking only bolds the phylogram's own path/label above; without this,
                // the linked human figure highlight only ever came from the incidental
                // hover that precedes a click, so it never actually persisted with the click.
                // Flagged as a click signal so it doesn't share a counter with hover (see
                // GiHuman's change_on_human) - otherwise the hover that always precedes a
                // real click double-counts, and a same-spot re-click without re-hovering
                // away first can't fully clear it.
                if(callback_after_mouseover_path){
                    callback_after_mouseover_path(child.data, selected, true);
                }
            }
        }

        if(isSelectedParent === false){
            if(pathD.target && pathD.target.children){
                childPathActive(pathD.target.children);

            }else if(pathD.target){
                childActive(pathD.target);
            }
        }
    }

    // Click with path
    function mouseClickOnPath(){
        return function(this: any, event: any, d: any) {

            let selected:boolean = d3.select(this).classed("selected") !== true;

            // Single-select: picking a new branch clears whichever branch(es)
            // were previously selected, so only one branch is ever highlighted
            // (in the tree, the grid below, and the linked human figure) at a time.
            if(selected){
                Object.keys(clickPathDatas).forEach(function(key){
                    if(key !== d.target.data.name){
                        let otherD:any = clickPathDatas[key];
                        if(otherD.target && otherD.target.linkNode){
                            applyPathSelection(otherD, otherD.target.linkNode, false);
                        }
                        delete clickPathDatas[key];
                    }
                });
            }

            applyPathSelection(d, this, selected);

            if(selected){
                clickPathDatas[d.target.data.name] = d;
            }else{
                delete clickPathDatas[d.target.data.name];
            }

            if(callback_after_click_path){
                callback_after_click_path(clickPathDatas);
            }
        }
    }

    function mouseoveredOnRect(d:any, active:boolean ){
        return function(this: any, event: any) {

            let lineageBackNode:any = d3.select(d.lineageBackNode);
            let lineageTextNode:any =  d3.select(d.lineageTextNode);

            if(active){
                lineageBackNode.attr("transform", lineageBackNode.attr("transform2"));
                lineageTextNode.attr("transform", lineageTextNode.attr("transform2"));
            }else{
                lineageBackNode.attr("transform", `translate( -100 , -100 )`);
                lineageTextNode.attr("transform", `translate( -100 , -100 )`);
            }
            
            lineageBackNode.classed("rect--active2", active).raise();
            lineageTextNode.classed("label--active2", active).raise();
        }
    }

    function mouseclickOnRect(bulkId:string, nodeData:any, highlightBulkRectG: any, highlightBulkG: any){
        return function(this: any, event: any, d: any) {

            let data:any;

            highlightBulkG.selectAll('rect')
                        .attr("stroke", "black")
                        .attr("stroke-width", 0);

            if(highlightBulkRectG){
                highlightBulkRectG.selectAll('rect')
                                .attr("stroke", "black")
                                .attr("stroke-width", 2);
            }

            if(nodeData){
                data = nodeData.node.data
            }else{
                data = d.target.data;
            }
            

            if(callback_after_click_reck) {
                callback_after_click_reck(bulkId, data);
            }
        }
    }

    function mouseoveredOnPath(active:boolean ){
        return function(this: any, event: any, d: any) {

            // On mouseover, sweep stale hover state first so a real stale entry
            // doesn't get re-added by this same call. On mouseout, the sweep instead
            // runs after the cascade below (see the bottom of this function) - that
            // cascade already removes/notifies for this event's own leaves, so
            // running the sweep before it would find them still in hoveredLeafData
            // and fire a second, duplicate "off" for each.
            if(active){
                clearHoverOnly();
            }

            let source = d.source;
            let target = d.target;

            if(!d3.select(this).classed("selected")) {
                d3.select(this).classed("link--active", active).raise();
            }

            // The branch-name popup (e.g. "L1-2") should still show on hover even
            // when the branch is already click-selected - only the bold/"selected"
            // styling above is guarded so hover doesn't fight with a click.
            let lineageBackNode:any = d3.select(target.lineageBackNode);
            let lineageTextNode:any =  d3.select(target.lineageTextNode);

            if(active){
                lineageBackNode.attr("transform", lineageBackNode.attr("transform2"));
                lineageTextNode.attr("transform", lineageTextNode.attr("transform2"));
            }else{
                lineageBackNode.attr("transform", `translate( -100 , -100 )`);
                lineageTextNode.attr("transform", `translate( -100 , -100 )`);
            }

            lineageBackNode.classed("rect--active2", active).raise();
            lineageTextNode.classed("label--active2", active).raise();

            // No .raise() through this ancestor/descendant cascade below: reordering
            // every one of these siblings under the cursor on each hover is what made
            // the browser lose track of which element a click should land on.
            do{
                if(source !==undefined && source.linkNode !== undefined && d3.select(source.linkNode).classed("selected") === false) {
                    d3.select(source.linkNode).classed("link--active", active);
                }
            }
            while (source = source.parent);


            function childPathActive(children:any[], active:boolean){
                children.forEach(child => {
                    childActive(child, active);
                })
            }

            function childActive(child:any, active:boolean){

                if(d3.select(child.linkNode).classed("selected") === undefined){
                    d3.select(child.linkNode).classed("selected", false);
                }

                if(child.linkNode !== undefined && d3.select(child.linkNode).classed("selected") === false) {
                    d3.select(child.linkNode).classed("link--active", active);
                }

                if(child.children){
                    childPathActive(child.children, active);
                }else{
                    if(child.textNode !== undefined){

                      if(d3.select(child.textNode).classed("selected") === undefined){
                        d3.select(child.textNode).classed("selected", false);
                      }

                      if(d3.select(child.textNode).classed("selected") === false) {
                        d3.select(child.linkExtensionNode).classed("link-extension--active", active);

                        if(active){
                            d3.select(child.textNode).attr("fill", d3.select(child.textNode).attr("fill2"));
                        }else{
                            d3.select(child.textNode).attr("fill", "black");
                        }

                        d3.select(child.textNode).classed("label--active", active);
                      }

                      // Notify even when the "selected" guard above skipped the visual
                      // update: hover and click are tracked as independent signals
                      // downstream (see GiHuman's change_on_human), so hover's own
                      // on/off must stay balanced even for a leaf that's also
                      // click-selected - otherwise this leaf's mouseover never gets a
                      // matching mouseout once it becomes selected mid-hover.
                      if(callback_after_mouseover_path){
                          callback_after_mouseover_path(child.data, active, false);
                      }
                      if(active){ hoveredLeafData.add(child.data); } else { hoveredLeafData.delete(child.data); }
                    }
                }
            }

            if(d.target && d.target.children){
                childPathActive(d.target.children, active);

            }else if(d.target){
                childActive(d.target, active);
            }

            // See the comment at the top of this function: on mouseout this cascade
            // has already removed/notified for its own leaves, so the stale-state
            // sweep is safe to run only now, after them.
            if(!active){
                clearHoverOnly();
            }

        }
    }

    useEffect(() => {
        svg= d3.select(svgRef.current)  
            //    .attr('width', width)
            //    .attr('height', height)
               .attr("viewBox", `0 0 ${width} ${height}`)
               .attr("preserveAspectRatio","xMidYMid meet")
               ;
        // initialization
        svg.selectAll("g").remove();

        treeGroup = svg.append('g')
                       .classed('tree', true)
                       .attr('transform', `translate(${plotMargins.left},${plotMargins.top})`);

        let xcales: any[] = scaleBranchLengths(nodes, treeWidth);

        // draw line of ticks

        xcales.forEach(xscale => {
            treeGroup.append('g')
                    .selectAll('line')
                    .data(xscale.domain())
                    .enter().append('line')
                    .attr('y1', 0)
                    .attr('y2', treeHeight)
                    .attr('x1', xscale)
                    .attr('x2', xscale)
                    .attr("stroke", "#ddd");

            treeGroup.append('g')
                    .selectAll("text.rule")
                    .data(xscale.domain())
                    .enter().append("svg:text")
                    .attr("class", "rule")
                    .attr("x", xscale)
                    .attr("y", 0)
                    .attr("dy", -3)
                    .attr("text-anchor", "middle")
                    .attr('font-size', '8px')
                    .attr('fill', '#000')
                    .text(function(d:any) { return Math.round(d*100) / 100; });
        });
        //drawTickLine(treeGroup, xscale2);

        // draw line 
        link = treeGroup.append("g")
                            .selectAll("path.link")
                            .data(tree.links())
                            .enter().append("path")
                            .each(function(d:any) { d.target.linkNode = this; })
                            .attr("class", "link")
                            .attr("d", rightAngleDiagonal())
                            .attr("fill", "none")
                            .attr('stroke', function(d:any){
                                if(color.domain().length > 0 && d.target.data.detailData !== undefined){
                                    return String(color(d.target.data.detailData[legend_field]));
                                }

                                if(d.target.xscale_index === 0){
                                    return "#330000"
                                }

                                return "#778899";
                             })
                            .attr("stroke-width", function(d:any){
                                if(d.target.xscale_index === 0){
                                    return "4px"
                                }               
                                return "2px";
                            })
                            .attr("stroke-opacity", "0.55")
                            .on("mouseover", mouseoveredOnPath(true))
                            .on("mouseout", mouseoveredOnPath(false));

        if(callback_after_click_path){                            
            link.on("click", mouseClickOnPath())
                .style("cursor", "pointer")
        }
          
        // link expension
        treeGroup.append("g").selectAll("path.link")
                 .data(tree.links().filter(d => !d.target.children))
                 .enter().append("path")
                 .each(function(d: any) { d.target.linkExtensionNode = this; })
                 .attr("stroke", "#000")
                 .attr("stroke-dasharray", "2,2")
                 .attr("stroke-width", "1px")
                 .attr("stroke-opacity", "0.25")
                 .attr("d", function(d: any) {
                     return "M" + d.target.y + ',' + d.target.x + ' ' + treeWidth + "," + d.target.x;
                 });

        

        // draw nodes
        let node = treeGroup.append("g")
                            .selectAll("g.node")
                            .data(nodes)
                            .enter()
                            .append("g")
                            // .append("circle")
                            // .attr("node-name", function(d:any) {
                            //     return d.data.name;
                            // })
                            // .attr("fill","#00000")
                            // .attr("r", 2)
                            .attr("class", function(n:any) {
                                if(n.parent){
                                    nodeMap[n.data.name] = {
                                        x: n.parent.y, 
                                        y: n.x, 
                                        xscale_index: n.parent.xscale_index,
                                        node: n
                                    };
                                }

                                if (n.children) {
                                    if (n.depth === 0) {
                                    return "root node"
                                    } else {
                                    return "inner node"
                                    }
                                } else {
                                    return "leaf node"
                                }
                            })
                            .attr("transform", function(d) { return "translate(" + d.y + "," + d.x + ")"; })

        // draw labels
        treeGroup.selectAll('g.inner.node')
                .append("svg:text")
                .attr("dx", -6)
                .attr("dy", -6)
                .attr("text-anchor", 'end')
                .attr('font-size', '9px')
                .attr('fill', '#1C1C1C')
                .text(function(d: any) { return d.data.length; });

        treeGroup.selectAll('g.leaf.node')
                .append("svg:text")
                .attr("dx", -2)
                .attr("dy", -2)
                .attr("text-anchor", 'end')
                .attr('font-size', '9px')
                .attr('fill', '#1C1C1C')
                .text(function(d: any) { return d.data.length; });

        // draw the label of lineage ID        
        let lineageLabelG = treeGroup.append("g").selectAll("g.node").data(nodes)
                                    .enter().append("g");
                                    
        lineageLabelG.append("text")
                     .each(function(d:any) { d.lineageTextNode = this; })
                     .attr("dx", 5)
                     .attr("dy", -5)
                     .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
                     .attr('font-size', '9px')
                     .attr("font-weight", "bold")
                     .attr("opacity", "0")
                     .attr('fill', '#000')
                     .text(function(d: any) { 
                             return d.data.name
                     })
                     .attr("transform", `translate( -100 , -100 )`)
                     .attr("transform2", function(d:any) { 
                         let x:number = 0;
                         if(d.parent){
                             x =  d.parent.y;
                         }
                         return `translate( ${x} , ${d.x} )`; 
                    })

        lineageLabelG.insert("rect", "text")
                    .each(function(d:any) { d.lineageBackNode = this; })
                    .attr("width", (d:any) => d.lineageTextNode.getComputedTextLength())
                    .attr("height", 10)
                    .attr("opacity", "0")
                    .attr("fill", "white")
                    .attr("transform", `translate( -100 , -100 )`)
                    .attr("transform2", function(d:any) { 
                        let x:number = 0;
                        if(d.parent){
                            x =  d.parent.y + 5;
                        }
                        return `translate( ${x} , ${d.x - 13} )`; 
                    })             

        // draw the label
        treeGroup.append("g").selectAll("g.node").data(nodes)
                 .enter().append("text")
                 .filter(function(node: any) { 
                      return !(node.children)
                    })
                 .each(function(d:any) { d.textNode = this; })
                 .attr("dx", 8)
                 .attr("dy", 3)
                 .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
                 .attr('font-size', '10px')
                 .attr("font-weight", "bold")
                 .attr('fill', '#000')
                 .attr('fill2', function(d:any){

                    if(color.domain().length > 0){
                        if(d.data.detailData && d.data.detailData[legend_field]){
                            return String(color(d.data.detailData[legend_field]));
                        }else{
                            return "#000000;"
                        }
                    }

                     return "black";
                 })
                 .text(function(d: any) { 
                    if(initData.detail_title_field !== undefined && d.data.detailData !== undefined){
                        return d.data.detailData[initData.detail_title_field.target_field];
                    }else{
                        return d.data.name 
                    }; 
                  })
                 .attr("transform", function(d) { return "translate(" + treeWidth + "," + d.x + ")"; })
                 .on("mouseover", mouseoveredOnLabel(true))
                 .on("mouseout", mouseoveredOnLabel(false));

        if(color.domain().length > 0){

            let beforePos:number = 0;

            let legendG = treeGroup.append("g").selectAll("g")
                                .data(color.domain())
                                .join("g")
                                .attr("transform", function(d, i){ 
                                    let returenValue:string =  `translate(${15 + beforePos}, -20)`;
                                    beforePos += 16 + (d.length * 5.2)
                                    return returenValue;
                                });

            legendG.append("rect")
                    .attr("width",8)
                    .attr("height", 8)
                    .attr("fill", (d) => String(color(d)));

            legendG.append("text")
                    .attr("x", 14)
                    .attr("y", 1)
                    .attr("dy", 6)
                    .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
                    .attr('font-size', '10px')
                    .text(d => d);
        }
        
        if(vaf_legend && vafColorScale){
            let vafColorScaleG:any = svg.append("g")
                                        .attr("transform", function(d) { return `translate(${18} ,${20})`; });

            svg.append("g")
               .attr("transform", function(d) { return `translate(${18} ,${5})`; })
               .append("text")
                .attr("dx", -10)
                .attr("dy", 6)
                .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
                .attr('font-size', '10px')
                .attr("font-weight", "bold")
                .text("VAF(%)");

            let canvas:any = vafColorScaleG.append("g")
                                           .append('foreignObject')
                                           .attr('width', plotMargins.vaf_legend_width)
                                           .attr('height', plotMargins.vaf_legend_height)
                                           .append('xhtml:canvas')
                                           .attr('xmlns', 'http://www.w3.org/1999/xhtml')
                                           .attr("height", plotMargins.vaf_legend_height)
                                           .attr("width", 1)
                                           .style("height", (plotMargins.vaf_legend_height) + "px")
                                           .style("width", (plotMargins.vaf_legend_width) + "px")
                                           .style("border", "1px solid #000")
                                           .node();  

            var ctx:any = canvas.getContext("2d");

            let vafLinealScale:any = d3.scaleSymlog()
                                        .range([0,plotMargins.vaf_legend_height])
                                        .domain([50, 0])
                                        .constant(2);


            var image = ctx.createImageData(1, plotMargins.vaf_legend_height);
            d3.range(plotMargins.vaf_legend_height).forEach(function(i) {
                var c = d3.rgb(vafColorScale(vafLinealScale.invert(i)));
                image.data[4*i] = c.r;
                image.data[4*i + 1] = c.g;
                image.data[4*i + 2] = c.b;
                image.data[4*i + 3] = 255;
            });
            ctx.putImageData(image, 0, 0);

            let legendaxis:any = d3.axisLeft(vafLinealScale)
                                   .tickSize(4)
                                   .tickValues([0, 2, 5,10, 20, 30, 50])
                                   
            
            vafColorScaleG.append('g').call(legendaxis);

            vafColorScaleG.selectAll("text").attr('font-size', '8px')
        }

        if(initData.onDrawVafRect && initData.draw_bulk_id){
            initData.onDrawVafRect(initData.draw_bulk_id)
        }

        // Safety net: if the pointer leaves the chart entirely without a
        // matching mouseout ever reaching every hovered node (see clearHoverOnly),
        // make sure nothing is left stuck highlighted.
        svg.on("mouseleave", clearHoverOnly);

    }, [data]);

    return (
        <React.Fragment>
            <svg ref={svgRef}>
            </svg>
        </React.Fragment>
    );
}

export default GiPhylogram;